/* @flow */

import { isEmpty } from 'ramda';
import * as React from 'react';
import createUseThemeStyles from 'src/shared/app/base/util/createUseThemeStyles';
import {
  getUserAvatar,
  getUserFullName,
} from '@braindate/domain/lib/user/util';
import DefaultUserAvatar from 'src/shared/components/domain/user/avatar/DefaultUserAvatar';
import Avatar from 'src/shared/ui/component/image/Avatar';
import styles from './GroupAvatarQueueAvatar.style';
import type { User } from '@braindate/domain/lib/user/type';

type Props = {
  participant: User,
  isFaded?: boolean,
  variant?: string,
};

const useStyles = createUseThemeStyles(styles);

const GroupAvatarQueueAvatar = ({
  participant,
  isFaded,
  variant,
}: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Classes
   |----------------------------------------------------------------------------
   */

  const classes = useStyles({ isFaded, variant });

  const avatar = getUserAvatar(participant);

  const props = {
    variant,
    alt: getUserFullName(participant),
  };
  if (avatar && !isEmpty(avatar)) {
    return <Avatar {...props} src={avatar} layoutClass={classes.root} />;
  }
  return (
    <DefaultUserAvatar
      {...props}
      user={participant}
      layoutClass={classes.root}
    />
  );
};

export default React.memo<Props>(GroupAvatarQueueAvatar);
